import { computed, useContext, useRoute } from '@nuxtjs/composition-api';

const WEBSITE_BANNERS_PATH = 'website-banner';

import {
  getStoriesAsArray,
  getStoryBlokVersion,
  useContent,
} from '@unified-commerce/gpc-vue-storefront-storyblok';

interface UseWebsiteBannerOptions {
  componentName?: string;
}

const useWebsiteBanner = ({ componentName = 'WebsiteBanner' }: UseWebsiteBannerOptions = {}) => {
  const { $config } = useContext();
  const route = useRoute();
  const { search: websiteBannerSearch, content: websiteBannerContent } =
    useContent(WEBSITE_BANNERS_PATH);

  const fetchWebsiteBanner = () => {
    websiteBannerSearch({
      url: WEBSITE_BANNERS_PATH,
      version: getStoryBlokVersion($config.ENV, route.value),
      custom: {
        filter_query: {
          component: {
            in: componentName,
          },
        },
        sort_by: 'published_at:desc',
      },
      optimisticStoryLoading: true,
    });
  };

  const websiteBannerSlides = computed(() => getStoriesAsArray(websiteBannerContent.value));

  const hasWebsiteBanner = computed(() => !!websiteBannerSlides?.value?.length);

  return {
    fetchWebsiteBanner,
    websiteBannerSlides,
    hasWebsiteBanner,
  };
};

export default useWebsiteBanner;
